import languages from '.'

const getUserLang = () => {
  let userLang = navigator.language
  const browserLang = languages.langs.find(lang => lang === userLang)

  userLang = browserLang ? browserLang : languages.defaultLangKey

  return userLang
}

export default getUserLang
